import { ApolloClient, InMemoryCache } from '@apollo/client'

export const apolloClient = new ApolloClient({
  uri: process.env.GATSBY_GRAPHQL_ENDPOINT,
  cache: new InMemoryCache({
    dataIdFromObject: o => o.id
  })
})
